<template>
  <overview
    :locationService = locationService
    :locationComponent = locationComponent
  ></overview>
</template>

<script>
import Overview from '@/components/Common/Rental/Locations/Overview'
import locationService from '@/services/rental/location'

export default {
  components: {
    Overview,
  },

  data () {
    return {
      locationService: locationService,
      locationComponent: 'RentalLocation',
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Rental/Locations/Overview.vue